var IPPODO = IPPODO || {};
/**
 * JSONの判定
 * @param {*} el
 * @returns
 */
IPPODO['jsonParse'] = (el) => {
  try {
    const json = JSON.parse(el.textContent);
    return json;
  } catch {
    console.error('error', 'JSONの形式がおかしいです。');
    return false;
  }
};
/**
 * Checkoutのカスタマイズ
 */
IPPODO['Checkout'] = {
  element() {
    return {
      data: '[data-product-size]',
      target: '[data-shipping-method-label-title]',
      first_target:
        '[data-shipping-methods] .content-box__row:first-of-type input.input-radio',
    };
  },
  text() {
    return {
      error: 'No Delivery company. ',
    };
  },
  init() {
    const productData = document.querySelector(this.element()?.data);
    const target = document.querySelectorAll(this.element()?.target);
    const data = IPPODO.jsonParse(productData);
    const shipmentData = IPPODO.shipping_table[data.countory];
    if (!data) return false;
    for (let i = 0; i < target.length; i++) {
      const result = this.shipmentChecker(shipmentData, data, target, i);
      if (!result) {
        target[i]?.closest('.content-box__row').remove();
        this.resetChecker();
      }
    }
    // 初めのラジオボタンを選択
    if (document.querySelector(this.element().first_target)) {
      document.querySelector(this.element().first_target).checked = true;
    }
  },
  /**
   * リミットを超えていないか
   * @param {*} limit
   * @param {*} data
   * @returns
   */
  limitChecker(limit, data) {
    if (data > limit) {
      return false;
    }
    return true;
  },
  /**
   * 配送業者の表示判定
   * weightを外す場合には記述をなくすだけでOK
   * @param {*} shipmentData
   * @param {*} data
   * @param {*} target
   * @param {*} key
   * @returns
   */
  shipmentChecker(shipmentData, data, target, key) {
    const shipment = target[key]?.dataset?.shippingMethodLabelTitle;
    if (!shipment) return false;
    let weight = true;
    let size = true;
    let status = true;

    if (shipment.includes('DHL')) {
      weight = this.limitChecker(shipmentData.DHL.weight, data.weight);
      size = this.limitChecker(shipmentData.DHL.size, data.size);
      status = shipmentData.DHL.status;
    } else if (shipment.includes('EMS')) {
      weight = this.limitChecker(shipmentData.EMS.weight, data.weight);
      size = this.limitChecker(shipmentData.EMS.size, data.size);
      status = shipmentData.EMS.status;
    } else if (shipment.includes('SAL')) {
      weight = this.limitChecker(shipmentData.SAL.weight, data.weight);
      size = this.limitChecker(shipmentData.SAL.size, data.size);
      status = shipmentData.SAL.status;
    } else {
      weight = this.limitChecker(shipmentData.ePacket.weight, data.weight);
      size = this.limitChecker(shipmentData.ePacket.size, data.size);
      status = shipmentData.ePacket.status;
    }
    // ステータスが非表示扱いなら非表示にする
    if (!status) {
      return false;
    }
    // 重さと容積の判定
    if (!weight || !size) {
      return false;
    }
    return true;
  },
  /**
   * 配送業者の表示が全てなくなってしまった場合のエラーテキスト表示
   */
  resetChecker() {
    const target = document.querySelectorAll(this.element()?.target);
    const parentTarget = document.querySelector(
      '.content-box[data-shipping-methods]',
    );
    if (target.length === 0) {
      parentTarget.innerHTML =
        '<p style="padding: 20px 15px;">' + this.text().error + '</p>';
    }
  },
  /**
   * 現状利用なし
   */
  // areaChecker(area, shipment) {
  //   if (shipment === 'EMS' || shipment === 'SAL') {
  //     return '第' + area.replace('Area', '') + '地帯'
  //   } else if (shipment === 'DHL') {
  //     return '区分' + area.replace('Area', '')
  //   } else {
  //     if (area === 'Area1') {
  //       return 'アジア'
  //     } else if (area === 'Area2') {
  //       return 'オセアニア、北米、中米、 中近東、ヨーロッパ'
  //     } else if (area === 'Area3') {
  //       return '南米、アフリカ'
  //     } else {
  //       return 'アメリカ合衆国（グアム等海外領土含む）'
  //     }
  //   }
  // }
};

/**
 * TODO: チェックアウトで選択するセレクトボックスの拡張
 * Developer: kanehori
 * 2023/06
 */
IPPODO['AddressSelectorCustom'] = {
  init() {
    this.element = {
      customerAddresses: '[data-wl-customer-addresses]',
      addressSelector: '[data-address-selector]',
    };
    this.customerAddresses = document.querySelector(
      this.element.customerAddresses,
    );
    this.addressSelector = document.querySelector(this.element.addressSelector);
    if (this.customerAddresses) {
      this.getAddress = this.jsonTry(this.customerAddresses.textContent);
    }

    if (this.getAddress && this.addressSelector) {
      this.setAddressSelector();
    }
  },
  jsonTry(content) {
    try {
      JSON.parse(content);
    } catch {
      console.error('予期せぬ値が含まれました');
      return false;
    }
    return JSON.parse(content);
  },
  setAddressSelector() {
    this.addressSelector.innerHTML = '';
    for (address of this.getAddress) {
      this.addressSelector.innerHTML += `<option data-properties='${JSON.stringify(
        address.address,
      )}' value="${address.address.id}" ${
        address.address.default == true ? 'selected' : ''
      }>${address.list_name}</option>`;
    }
    this.addressSelector.innerHTML +=
      '<option value="">新しい住所を使用する</option>';
  },
};

/**
 * TODO: 表書きのテキストを修正
 * Developer: kanehori
 * 2023/06
 */
IPPODO['noshiTextReplace'] = {
  init() {
    const omotegaki = document.querySelector('[name="noshi-content"]');
    const name = document.querySelector('[name="noshi-recipient"]');
    this.replaceEvt(omotegaki);
    this.replaceEvt(name);
  },
  replaceEvt(elm) {
    elm.addEventListener('keyup', (e) => {
      e.target.value = e.target.value.replaceAll(',', '，');
      e.target.value = e.target.value.replaceAll('"', '＂');
      e.target.value = e.target.value.replaceAll("'", '＇');
    });
  },
};
